import React, { ReactNode } from 'react';
import { footerStyle } from './Style';

export const Footer: React.FC<{ children?: ReactNode }> = ({ children }) => {
    return <div className={footerStyle.container}>{children}</div>;
};
